import { ParticipantsList } from 'src/pages/goldenMay2026/participants/list'

export const GoldenMay2026ParticipantsPage = () => {
  return <ParticipantsList />
}
